import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_PAYMENT: 'FETCH_PAYMENT',
  FETCH_PAYMENTS: 'FETCH_PAYMENTS',
  ASSIGN_TO_CREDITOR: 'ASSIGN_TO_CREDITOR',
  REFUND_PAYMENT: 'REFUND_PAYMENT',
  GET_AVAILABLE_INSTALLMENT: 'GET_AVAILABLE_INSTALLMENT',
  DIVING_PAYMENT: 'DIVING_PAYMENT',
  SHIFT_PAYMENT: 'SHIFT_PAYMENT',
};

export default {
  fetchPayment: paymentId => {
    return apiClient.get(`/payment/${paymentId}`, {
      apiCallId: apiCallIds.FETCH_PAYMENT,
    });
  },

  fetchPayments: options => {
    return apiClient.get(`/payment?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_PAYMENTS,
    });
  },

  assignToCreditor: (paymentId, accountId) => {
    return apiClient.put(
      `/payment/${paymentId}`,
      { accountId },
      { apiCallId: apiCallIds.ASSIGNT_TO_CREDITOR }
    );
  },

  refundPayment: (paymentId, data) => {
    return apiClient.put(`/payment/${paymentId}/refund`, data, { apiCallId: apiCallIds.REFUND_PAYMENT });
  },

  assignToInstallment: (paymentId, loanId) => {
    return apiClient.put(`/payment/${paymentId}`, { loanId });
  },

  getAvailableInstallment: (paymentId, loanId) => {
    return apiClient.get(`/payment/${paymentId}/loan/${loanId}/getAvailableInstallment`, {
      apiCallId: apiCallIds.GET_AVAILABLE_INSTALLMENT,
    });
  },

  dividingPayment: (paymentId, data) => {
    return apiClient.post(`/payment/${paymentId}/dividing`, data , {
      apiCallId: apiCallIds.DIVIDING_PAYMENT,
    });
  },

  shiftPayment: (paymentId, loanId) => {
    return apiClient.put(`/payment/${paymentId}/shift`, { loanId },{
      apiCallId: apiCallIds.SHIFT_PAYMENT
    })
  }
};



// WEBPACK FOOTER //
// ./src/features/payment-management/api/index.js